export const BUTTON_ICON_MINIMIZE_POSITION = {
  bottom: 'bottom',
  top: 'top',
}

export const BUTTON_ICON_MINIMIZE_CLASSNAME_MODIFIERS = {
  bottom: {
    16: 'bottom16',
    24: 'bottom24',
  },
  top: {
    16: 'top16',
    24: 'top24',
  },
}
